// extracted by mini-css-extract-plugin
export default {"activeMenu":"MenuMobile_activeMenu__R1yMJ","wrapper":"MenuMobile_wrapper__b3AAY"};